var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.034,
    height: 38,
    viewBox: "0 0 38.034 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.035,
    height: 38,
    fill: "#0087ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,32.581a9.076,9.076,0,0,0-.956-9.859,9.37,9.37,0,0,0-5.605-3.642.317.317,0,0,1-.241-.308V.022A.02.02,0,0,0,30.181,0H15.823c-4.311,0-7.807,0-11,.007A4.817,4.817,0,0,0,1.376,1.384,4.826,4.826,0,0,0,.005,4.826C0,14.036,0,23.425.005,32.732a5.251,5.251,0,0,0,5.228,5.237l3.933.012c2.965.01,6.031.02,9.047.02,3.977,0,7.28-.017,10.394-.054A8.973,8.973,0,0,0,37,32.581M8.75,2.271a.319.319,0,0,1,.318-.318H27.9a.319.319,0,0,1,.318.318V18.516a.319.319,0,0,1-.278.315,10.659,10.659,0,0,0-6.1,2.625,10.8,10.8,0,0,0-3.024,5.951.319.319,0,0,1-.311.257H9.069a.319.319,0,0,1-.318-.318Zm-6.8,2.745A2.82,2.82,0,0,1,5.057,1.9l.548,0H6.4a.319.319,0,0,1,.319.318V27.382A.318.318,0,0,1,6.4,27.7H6.344a7,7,0,0,0-3.878.778.317.317,0,0,1-.484-.238,4.4,4.4,0,0,1-.03-.442c0-6.79,0-14.806,0-22.781M21.914,35.834a.311.311,0,0,1-.288.192h-8.76c-3.039,0-5.5,0-7.758-.008a3.158,3.158,0,0,1-2.985-2.144,2.961,2.961,0,0,1,1.015-3.452,3.953,3.953,0,0,1,2.068-.72c2.421-.034,4.859-.039,6.924-.039h4.257l1.822,0c.376,0,.728.079.793.65a6.272,6.272,0,0,0,.194.895c.023.085.046.172.069.261a.319.319,0,0,1-.308.4H5.731a.979.979,0,0,0,0,1.957h6.9c1.907,0,4.422,0,6.963-.015h.018a1.45,1.45,0,0,1,1.355.665,6.8,6.8,0,0,0,.722.838l.162.17a.32.32,0,0,1,.061.346m6.477.243h-.028a7.631,7.631,0,0,1,.027-15.262h.033a7.631,7.631,0,0,1-.032,15.262",
    transform: "translate(0)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.56,180.523l-.023-.068,0-.014,0-.014c-.031-.238-.087-.287-.1-.287h-.009c-.035.005-.069.012-.1.02a1.285,1.285,0,0,1-.256.036c-.509,0-.577-.42-.577-.831v-4.624c0-.305-.093-.4-.4-.4h-.494c-.305,0-.4.093-.4.4v4.637c0,1.456.536,1.748,1.4,1.748a2.232,2.232,0,0,0,.717-.1c.213-.058.3-.144.246-.5",
    transform: "translate(-157.51 -148.281)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.327,158.146h.588c.3,0,.4-.1.4-.4v-.615c0-.305-.093-.4-.4-.4h-.588c-.305,0-.4.093-.4.4v.615c0,.3.1.4.4.4",
    transform: "translate(-157.282 -133.304)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.284,78.256H94.663a.952.952,0,0,0,0-1.9H84.284a.952.952,0,1,0,0,1.9",
    transform: "translate(-70.874 -64.939)",
    fill: "#0087ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.043,44.988a.953.953,0,0,0,.952.952h5.682a.952.952,0,0,0,0-1.9H99.995a.953.953,0,0,0-.952.952",
    transform: "translate(-84.237 -37.453)",
    fill: "#0087ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManual);
export default __webpack_public_path__ + "static/media/manual.8435c9b6139ba4d9f54c9ccaa7b4f907.svg";
export { ForwardRef as ReactComponent };